import React, { useState, createContext, useContext } from 'react';
import { Box } from '@mui/material';

// Create context to share fullscreen state with children
export const FullscreenContext = createContext({
  isFullScreen: false,
  toggleFullScreen: () => {},
});

export const useFullscreen = () => useContext(FullscreenContext);

// This component will wrap your DataGrid
export const FullscreenContainer = ({ children, className = '' }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  const toggleFullScreen = () => {
    setIsFullScreen(prev => !prev);
  };

  return (
    <FullscreenContext.Provider value={{ isFullScreen, toggleFullScreen }}>
      <Box
        className={`fullscreen-container ${isFullScreen ? 'fullscreen-active' : ''} ${className}`}
        sx={{
          position: isFullScreen ? 'fixed' : 'relative',
          top: isFullScreen ? 0 : 'auto',
          left: isFullScreen ? 0 : 'auto',
          width: isFullScreen ? '100vw' : '100%',
          height: isFullScreen ? '100vh' : '100%',
          zIndex: isFullScreen ? 1300 : 'auto',
          backgroundColor: isFullScreen ? 'background.paper' : 'transparent',
          padding: isFullScreen ? 3 : 0,
          boxSizing: 'border-box',
          overflow: 'auto',
          '& .MuiDataGrid-root': {
            height: isFullScreen ? 'calc(100vh - 56px)' : '100%',
            width: isFullScreen ? 'calc(100vw - 48px)' : '100%',
          }
        }}
      >
        {children}
      </Box>
    </FullscreenContext.Provider>
  );
};